import React from 'react'
import { MenuItem, MenuDivider } from '@szhsin/react-menu'
import { Tooltip } from '@chakra-ui/react'
import { Trans, useTranslation } from 'react-i18next'
import { colors } from '../../../../ui-kit'
import Hover from '../../Hover'
import { MenuItemWithTooltipProps } from '../../../interfaces'


const MenuItemWithTooltip: React.FC<MenuItemWithTooltipProps> = ({
  item,
  ind,
  itemInd,
}) => {
  const optionDisabledInfo = item.optionDisabledInfo
    ? item.optionDisabledInfo()
    : undefined
  const assetName = optionDisabledInfo?.assetName
  const remainingLength = optionDisabledInfo?.remainingLength
  const { t } = useTranslation()
  let tooltipLabel

  if (optionDisabledInfo?.tooltipMessage) {
    tooltipLabel = optionDisabledInfo.tooltipMessage
  } else if (remainingLength === 0) {
    tooltipLabel = (
      <Trans t={t} i18nKey="context_menu_disable_tooltip_one_asset">
        You do not have sufficient permissions to perform this action on{' '}
        {{ assetName }}.
      </Trans>
    )
  } else {
    tooltipLabel = (
      <Trans t={t} i18nKey="context_menu_disable_tooltip">
        You do not have sufficient permissions to perform this action on{' '}
        {{ assetName }} and {{ remainingLength }} more items.
      </Trans>
    )
  }

  return (
    <Tooltip
      isDisabled={!optionDisabledInfo?.isDisabled}
      label={tooltipLabel}
      shouldWrapChildren
      placement="right-end"
      hasArrow
      key={itemInd ? `tooltip-${ind}-${itemInd}` : `tooltip-${ind}`}
    >
      <Hover>
        {isHover => (
          <MenuItem
            style={{
              cursor: optionDisabledInfo?.isDisabled
                ? 'not-allowed'
                : 'pointer',
              color: item.name.includes('Delete') ? colors.appBrick : 'inherit',
            }}
            onClick={() => {
              if (item.trigger) {
                item.trigger()
              }
            }}
            disabled={Boolean(optionDisabledInfo?.isDisabled)}
            key={itemInd ? `item-${ind}-${itemInd}` : `item-${ind}`}
          >
            {item.element ? item.element({ isHover }) : item.name}
          </MenuItem>
        )}
      </Hover>
    </Tooltip>
  )
}

export default React.memo(MenuItemWithTooltip)
